export default "__VITE_ASSET__BYDj8pTy__"